import React from 'react';
import styled from 'styled-components';
import {
  COLOR_BUTTON_PRIMARY_050,
  COLOR_BUTTON_PRIMARY,
  COLOR_WHITE,
} from '@common/assets/styles/colors';
import { useSelector } from 'react-redux';
import { TRootState } from '@store/root-reducer';
import {HilbiWidgetViews} from "@store/user-interface/type";

const ProgressBarSC = styled.div`
  display: block;
  width: 100%;

  .content {
    height: 2px;
    width: 100%;
    background-color: ${COLOR_WHITE};
    display: flex;
    justify-content: flex-start;
    padding-left: 20px;
    padding-right: 20px;

    margin-top: 16px;
    margin-bottom: 32px;

    .col {
      width: 100%;
      border-radius: 1px;
      margin-right: 3px;
      background-color: ${COLOR_BUTTON_PRIMARY_050};

      &.active {
        background-color: ${COLOR_BUTTON_PRIMARY};
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

const ProgressBar = () => {
  const currentStep = useSelector(
    (store: TRootState) => store.userInterface.currentStep,
  );


  if (currentStep > HilbiWidgetViews.OrderRecap) {
    return null;
  }

  return (
    <ProgressBarSC>
      <div className={'content'}>
        {[0, 0, 0, 0].map((el, idx) => (
          <div
            key={idx}
            className={`col ${currentStep >= idx ? 'active' : ''}`}
          />
        ))}
      </div>
    </ProgressBarSC>
  );
};

export default ProgressBar;
